/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LocationPinIcon24Solid = forwardRef('LocationPinIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.503 6.57c-2.88 5.658 1.758 10.895 5.78 15.251a2.33 2.33 0 0 0 3.417-.012c3.978-4.342 8.627-9.467 5.85-15.131-1.43-2.914-4.322-4.682-7.55-4.682-3.184 0-6.045 1.722-7.497 4.574Zm7.496 7.934a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" })));
});
